import {FormDrawer} from './FormDrawer';
import {DrawerProps} from '@mantine/core';
import {useProduct} from '../hooks/useProduct';
import {Product} from '../types';

export const AddFormDrawer = (props: DrawerProps) => {

    const {createRecord} = useProduct();

    return (
        <FormDrawer
            record={{
                id: '',
                name: '',
                description: '',
                url: '',
            } as Product}
            handleSubmit={createRecord}
            {...props}
        />
    );
};
